import React, { useMemo } from "react";
import { DollarSign } from "lucide-react";
import { CustomProcessCard } from "./CustomProcessCard";
import { formatCurrencyBRL } from "../../lib/utils";

export function CustomProcessList({
  processes,
  selectedIds,
  setSelectedIds,
  hideCheckbox = false,
}) {
  const handleToggle = (id, checked) => {
    if (checked) {
      setSelectedIds([...selectedIds, id]);
    } else {
      setSelectedIds(selectedIds.filter((pid) => pid !== id));
    }
  };

  const { totalValor, totalFgts } = useMemo(() => {
    return processes.reduce(
      (acc, p) => {
        const exibirFgts = p.processo?.exibir_fgts === true;
        return {
          totalValor: acc.totalValor + Number(p.valor_proposta_final || 0),
          totalFgts: acc.totalFgts + (exibirFgts ? Number(p.valor_fgts || 0) : 0),
        };
      },
      { totalValor: 0, totalFgts: 0 },
    );
  }, [processes]);

  if (!processes || processes.length === 0) {
    return (
      <div className="text-center p-8 bg-[#f7f7f7] rounded-xl border border-dashed border-[#e0e0e0]">
        <p className="text-[#616161]">Nenhum processo encontrado.</p>
      </div>
    );
  }

  const hasFgts = totalFgts > 0;

  return (
    <div className="mb-6 md:mb-10">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-7 h-7 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-lg flex items-center justify-center shadow-md bg-gradient-to-br from-blue-600 to-blue-500 shrink-0">
          <DollarSign className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
        </div>
        <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground">
          Valores a receber
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-3 md:gap-4 mb-4 md:mb-6">
        {processes.map((process) => (
          <CustomProcessCard
            key={process.id}
            process={process}
            isSelected={selectedIds.includes(process.id)}
            onToggle={handleToggle}
            hideCheckbox={hideCheckbox}
          />
        ))}
      </div>

      {totalValor > 0 && (
        <div className="bg-brand-charcoal dark:bg-[#2A2C27] rounded-2xl px-5 py-4 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold text-white/60 uppercase tracking-widest">
              {hasFgts ? "Total parcelado" : "Total estimado"}
            </span>
            <span className="text-2xl sm:text-3xl font-black text-white tracking-tight leading-none">
              {formatCurrencyBRL(totalValor)}
            </span>
          </div>
          {hasFgts && (
            <div className="flex items-center justify-between border-t border-white/20 pt-3">
              <span className="text-xs font-semibold text-amber-400 uppercase tracking-widest">
                Via conta vinculada (FGTS)
              </span>
              <span className="text-base font-black text-amber-300">
                {formatCurrencyBRL(totalFgts)}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
